import GastoApi from '../../apis/Gasto';

export default {
    namespaced: true,
    state: {
        gastos: []
    },
    mutations: {
        set_gastos (state, data) {
            state.gastos = data;
        }
    },
    actions: {
        async getGastos({commit, dispatch}, filters) {
            return await GastoApi.get_all(filters)
                .then( response => {
                    commit('set_gastos', response.data)
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async store({dispatch}, gasto) {
            return await GastoApi.store(gasto)
                .then( response => {
                    if (response.status === 203) {
                        dispatch(
                            "notifications/store_notification",
                            {
                              type: "error",
                              message:
                                response.data.message ||
                                "Ocurrió un error al registrar, vuelva a intentarlo.",
                            },
                            { root: true }
                          );
                    }else{
                        dispatch('notifications/store_notification', {
                            type: 'success',
                            message: 'El registro se realizó de forma correcta.'
                        }, {root: true});
                        dispatch('getGastos')
                    }
                })
                .catch( error => {
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async update({dispatch}, gasto) {
            return await GastoApi.update(gasto)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La actualización se realizó de forma correcta'
                    }, {root: true});
                    dispatch('getGastos')
                })
                .catch( error => {
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async change_status({dispatch}, gasto) {
            let action = (gasto.active) ? 'inactivación' : 'activación';
            return await GastoApi.change_status(gasto)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La ' + action + ' se relizó de forma correcta.'
                    }, {root: true});
                    dispatch('getGastos')
                })
                .catch( error => {
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async delete({dispatch}, gasto) {
            return await GastoApi.delete(gasto)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La eliminación se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getGastos')
                })
                .catch( error => {
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                    }, {root: true});
                })
        }
    }
}